import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import { Provider } from "react-redux";
import { BrowserRouter} from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";

import * as Sentry from "@sentry/react";
import { PostHogProvider} from 'posthog-js/react'
import ReactGA from 'react-ga4';

// Initialize Sentry with reduced sampling for performance
Sentry.init({
  dsn: "https://e1c288fa32b95ea8e1b53e2687623910@o307544.ingest.us.sentry.io/4509275654062080",
  sendDefaultPii: true,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.5,
  tracesSampleRate: 0.1,
  release: "Blinkz@1.0.0",
  beforeSend(event, hint) {
    if (event.request?.url?.includes('/cart') || event.request?.url?.includes('/checkout')) {
      return null;
    }
    return event;
  }
});

// Take scroll position on navigation into our own hands (see MainLayout's
// scroll-to-top effect in App.jsx) instead of letting the browser silently
// restore whatever offset was last recorded for a URL, which was racing
// with that effect and occasionally left product pages scrolled down.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const POSTHOG_KEY = 'phc_5sCTMsi2M0L3LVmwtl8qcmybil8mkPxnc8tzr6fMFN2';
const GA_MEASUREMENT_ID = process.env.REACT_APP_PUBLIC_GA_MEASUREMENT_ID;

const options = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2026-05-30',
  capture_pageview: true,
  debug: false,
  disable_session_recording: true,
  capture_performance: false,
};

// Lazy initialize Google Analytics after first render
if (GA_MEASUREMENT_ID) {
  window.addEventListener('load', () => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }, { once: true });
}

const AppWithOptionalPostHog = (
  <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
    <App />
  </PostHogProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistProvider>
      <React.StrictMode>
        <BrowserRouter>
          <HelmetProvider>
            <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
                  {AppWithOptionalPostHog}
            </Sentry.ErrorBoundary>
          </HelmetProvider>
        </BrowserRouter>
      </React.StrictMode>
    </PersistProvider>
  </Provider>
);
